var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
// eslint-disable-next-line import/no-extraneous-dependencies
import { noop } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useRef, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import MaskedTextInput from 'react-text-mask';
// eslint-disable-next-line import/no-extraneous-dependencies
import { twMerge } from 'tailwind-merge';
import { getTestSelector } from '../../utilities/tests';
import FormControlWrapper from './FormControlWrapper';
var dateDigitPlaceholder = /[a-zA-Z]/;
var dateDigit = /\d/;
function getMask(placeholder) {
    if (!placeholder) {
        return false;
    }
    return placeholder.split('').map(function (char) { return (dateDigitPlaceholder.test(char) ? dateDigit : char); });
}
export default function DatePicker(_a) {
    var id = _a.id, label = _a.label, htmlName = _a.htmlName, defaultValue = _a.defaultValue, placeholder = _a.placeholder, error = _a.error, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c, wrapperProps = _a.wrapperProps, inputProps = _a.inputProps, labelProps = _a.labelProps, setSelected = _a.setSelected, selected = _a.selected, _d = _a.testSelector, testSelector = _d === void 0 ? getTestSelector(label) : _d, tooltip = _a.tooltip, srLabel = _a.srLabel, _e = _a.size, size = _e === void 0 ? 'md' : _e, _f = _a.color, color = _f === void 0 ? 'orange' : _f;
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    var inputElement = useRef();
    var invalid = error ? (error === null || error === void 0 ? void 0 : error.length) > 0 : false;
    var placeholderVal = disabled ? undefined : placeholder !== null && placeholder !== void 0 ? placeholder : getLocaleDateString().toUpperCase();
    var mask = getMask(getLocaleDateString().toUpperCase());
    var _h = inputProps || {}, inputClassName = _h.className, restInputProps = __rest(_h, ["className"]);
    return (_jsx(_Fragment, { children: _jsx(FormControlWrapper, { id: id, label: label, htmlName: htmlName, error: error, required: required, wrapperProps: wrapperProps, labelProps: labelProps, tooltip: tooltip, srLabel: srLabel, children: _jsxs("div", { className: clsx('w-full relative flex items-center border rounded-md min-w-xs bg-gray-250 cursor-pointer', !disabled && color === 'orange' && 'border-oncolensOrange-500 shadow-sm', !disabled && color === 'neutral' && 'border-slate-200', !srLabel && 'mt-1'), children: [_jsx(ReactDatePicker, __assign({ onClickOutside: function () {
                            setIsOpen(false);
                        }, ref: inputElement, autoComplete: "off", open: isOpen, className: twMerge('w-full text-sm border-opacity-0 border-none rounded-md rounded-r-none outline-none focus:border-oncolensOrange-50 focus-within:border-oncolensOrange-50 focus:ring-0', disabled && 'cursor-not-allowed border bg-gray-50 border-gray-300 text-gray-300', inputClassName), name: htmlName, wrapperClassName: "w-full", id: id, placeholderText: placeholderVal, portalId: "datepicker-portal", disabled: disabled, showYearDropdown: true, dropdownMode: "select", dateFormat: getLocaleDateString(), ariaInvalid: invalid.toString(), ariaDescribedBy: invalid ? "invalid-".concat(id) : undefined, ariaRequired: required ? 'true' : undefined, onChange: function (e) {
                            setSelected(e);
                        }, onSelect: function (e) {
                            setSelected(e);
                            setIsOpen(false);
                        }, onInputClick: function () {
                            setIsOpen(true);
                        }, onKeyDown: function (e) {
                            if (e.key === 'Enter' || e.key === 'Tab') {
                                setIsOpen(false);
                            }
                        }, 
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        onFocus: function (e) {
                            setIsOpen(true);
                        }, 
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        onBlur: function (e) {
                            setIsOpen(false);
                        }, onCalendarClose: function () { return setIsOpen(false); }, selected: selected || defaultValue, customInput: _jsx(MaskedTextInput, { "data-cy": testSelector, className: twMerge(size === 'sm' && 'py-1.5 px-2', size === 'md' && 'py-2 px-3', !disabled &&
                                color === 'neutral' &&
                                'cursor-not-allowed border bg-gray-50 border-gray-300 text-gray-300'), mask: mask }) }, restInputProps)), _jsx(FaCalendarAlt, { onClick: disabled
                            ? noop
                            : function () {
                                setIsOpen(true);
                                inputElement.current.setFocus();
                            }, className: "w-10 text-gray-400", "data-public": "true" })] }) }) }));
}
function getLocaleDateString() {
    var formats = {
        'af-ZA': 'yyyy/MM/dd',
        'am-ET': 'd/M/yyyy',
        'ar-AE': 'dd/MM/yyyy',
        'ar-BH': 'dd/MM/yyyy',
        'ar-DZ': 'dd-MM-yyyy',
        'ar-EG': 'dd/MM/yyyy',
        'ar-IQ': 'dd/MM/yyyy',
        'ar-JO': 'dd/MM/yyyy',
        'ar-KW': 'dd/MM/yyyy',
        'ar-LB': 'dd/MM/yyyy',
        'ar-LY': 'dd/MM/yyyy',
        'ar-MA': 'dd-MM-yyyy',
        'ar-OM': 'dd/MM/yyyy',
        'ar-QA': 'dd/MM/yyyy',
        'ar-SA': 'dd/MM/yy',
        'ar-SY': 'dd/MM/yyyy',
        'ar-TN': 'dd-MM-yyyy',
        'ar-YE': 'dd/MM/yyyy',
        'arn-CL': 'dd-MM-yyyy',
        'as-IN': 'dd-MM-yyyy',
        'az-Cyrl-AZ': 'dd.MM.yyyy',
        'az-Latn-AZ': 'dd.MM.yyyy',
        'ba-RU': 'dd.MM.yy',
        'be-BY': 'dd.MM.yyyy',
        'bg-BG': 'dd.M.yyyy',
        'bn-BD': 'dd-MM-yy',
        'bn-IN': 'dd-MM-yy',
        'bo-CN': 'yyyy/M/d',
        'br-FR': 'dd/MM/yyyy',
        'bs-Cyrl-BA': 'd.M.yyyy',
        'bs-Latn-BA': 'd.M.yyyy',
        'ca-ES': 'dd/MM/yyyy',
        'co-FR': 'dd/MM/yyyy',
        'cs-CZ': 'd.M.yyyy',
        'cy-GB': 'dd/MM/yyyy',
        'da-DK': 'dd-MM-yyyy',
        'de-AT': 'dd.MM.yyyy',
        'de-CH': 'dd.MM.yyyy',
        'de-DE': 'dd.MM.yyyy',
        'de-LI': 'dd.MM.yyyy',
        'de-LU': 'dd.MM.yyyy',
        'dsb-DE': 'd. M. yyyy',
        'dv-MV': 'dd/MM/yy',
        'el-GR': 'd/M/yyyy',
        'en-029': 'MM/dd/yyyy',
        'en-AU': 'd/MM/yyyy',
        'en-BZ': 'dd/MM/yyyy',
        'en-CA': 'dd/MM/yyyy',
        'en-GB': 'dd/MM/yyyy',
        'en-IE': 'dd/MM/yyyy',
        'en-IN': 'dd-MM-yyyy',
        'en-JM': 'dd/MM/yyyy',
        'en-MY': 'd/M/yyyy',
        'en-NZ': 'd/MM/yyyy',
        'en-PH': 'M/d/yyyy',
        'en-SG': 'd/M/yyyy',
        'en-TT': 'dd/MM/yyyy',
        'en-US': 'MM/dd/yyyy',
        'en-ZA': 'yyyy/MM/dd',
        'en-ZW': 'M/d/yyyy',
        'es-AR': 'dd/MM/yyyy',
        'es-BO': 'dd/MM/yyyy',
        'es-CL': 'dd-MM-yyyy',
        'es-CO': 'dd/MM/yyyy',
        'es-CR': 'dd/MM/yyyy',
        'es-DO': 'dd/MM/yyyy',
        'es-EC': 'dd/MM/yyyy',
        'es-ES': 'dd/MM/yyyy',
        'es-GT': 'dd/MM/yyyy',
        'es-HN': 'dd/MM/yyyy',
        'es-MX': 'dd/MM/yyyy',
        'es-NI': 'dd/MM/yyyy',
        'es-PA': 'MM/dd/yyyy',
        'es-PE': 'dd/MM/yyyy',
        'es-PR': 'dd/MM/yyyy',
        'es-PY': 'dd/MM/yyyy',
        'es-SV': 'dd/MM/yyyy',
        'es-US': 'M/d/yyyy',
        'es-UY': 'dd/MM/yyyy',
        'es-VE': 'dd/MM/yyyy',
        'et-EE': 'd.MM.yyyy',
        'eu-ES': 'yyyy/MM/dd',
        'fa-IR': 'MM/dd/yyyy',
        'fi-FI': 'd.M.yyyy',
        'fil-PH': 'M/d/yyyy',
        'fo-FO': 'dd-MM-yyyy',
        'fr-BE': 'd/MM/yyyy',
        'fr-CA': 'yyyy-MM-dd',
        'fr-CH': 'dd.MM.yyyy',
        'fr-FR': 'dd/MM/yyyy',
        'fr-LU': 'dd/MM/yyyy',
        'fr-MC': 'dd/MM/yyyy',
        'fy-NL': 'd-M-yyyy',
        'ga-IE': 'dd/MM/yyyy',
        'gd-GB': 'dd/MM/yyyy',
        'gl-ES': 'dd/MM/yy',
        'gsw-FR': 'dd/MM/yyyy',
        'gu-IN': 'dd-MM-yy',
        'ha-Latn-NG': 'd/M/yyyy',
        'he-IL': 'dd/MM/yyyy',
        'hi-IN': 'dd-MM-yyyy',
        'hr-BA': 'd.M.yyyy.',
        'hr-HR': 'd.M.yyyy',
        'hsb-DE': 'd. M. yyyy',
        'hu-HU': 'yyyy. MM. dd.',
        'hy-AM': 'dd.MM.yyyy',
        'id-ID': 'dd/MM/yyyy',
        'ig-NG': 'd/M/yyyy',
        'ii-CN': 'yyyy/M/d',
        'is-IS': 'd.M.yyyy',
        'it-CH': 'dd.MM.yyyy',
        'it-IT': 'dd/MM/yyyy',
        'iu-Cans-CA': 'd/M/yyyy',
        'iu-Latn-CA': 'd/MM/yyyy',
        'ja-JP': 'yyyy/MM/dd',
        'ka-GE': 'dd.MM.yyyy',
        'kk-KZ': 'dd.MM.yyyy',
        'kl-GL': 'dd-MM-yyyy',
        'km-KH': 'yyyy-MM-dd',
        'kn-IN': 'dd-MM-yy',
        'ko-KR': 'yyyy. MM. dd',
        'kok-IN': 'dd-MM-yyyy',
        'ky-KG': 'dd.MM.yy',
        'lb-LU': 'dd/MM/yyyy',
        'lo-LA': 'dd/MM/yyyy',
        'lt-LT': 'yyyy.MM.dd',
        'lv-LV': 'yyyy.MM.dd.',
        'mi-NZ': 'dd/MM/yyyy',
        'mk-MK': 'dd.MM.yyyy',
        'ml-IN': 'dd-MM-yy',
        'mn-MN': 'yy.MM.dd',
        'mn-Mong-CN': 'yyyy/M/d',
        'moh-CA': 'M/d/yyyy',
        'mr-IN': 'dd-MM-yyyy',
        'ms-BN': 'dd/MM/yyyy',
        'ms-MY': 'dd/MM/yyyy',
        'mt-MT': 'dd/MM/yyyy',
        'nb-NO': 'dd.MM.yyyy',
        'ne-NP': 'M/d/yyyy',
        'nl-BE': 'd/MM/yyyy',
        'nl-NL': 'd-M-yyyy',
        'nn-NO': 'dd.MM.yyyy',
        'nso-ZA': 'yyyy/MM/dd',
        'oc-FR': 'dd/MM/yyyy',
        'or-IN': 'dd-MM-yy',
        'pa-IN': 'dd-MM-yy',
        'pl-PL': 'dd.MM.yyyy',
        'prs-AF': 'dd/MM/yy',
        'ps-AF': 'dd/MM/yy',
        'pt-BR': 'd/M/yyyy',
        'pt-PT': 'dd-MM-yyyy',
        'qut-GT': 'dd/MM/yyyy',
        'quz-BO': 'dd/MM/yyyy',
        'quz-EC': 'dd/MM/yyyy',
        'quz-PE': 'dd/MM/yyyy',
        'rm-CH': 'dd/MM/yyyy',
        'ro-RO': 'dd.MM.yyyy',
        'ru-RU': 'dd.MM.yyyy',
        'rw-RW': 'M/d/yyyy',
        'sa-IN': 'dd-MM-yyyy',
        'sah-RU': 'MM.dd.yyyy',
        'se-FI': 'd.M.yyyy',
        'se-NO': 'dd.MM.yyyy',
        'se-SE': 'yyyy-MM-dd',
        'si-LK': 'yyyy-MM-dd',
        'sk-SK': 'd. M. yyyy',
        'sl-SI': 'd.M.yyyy',
        'sma-NO': 'dd.MM.yyyy',
        'sma-SE': 'yyyy-MM-dd',
        'smj-NO': 'dd.MM.yyyy',
        'smj-SE': 'yyyy-MM-dd',
        'smn-FI': 'd.M.yyyy',
        'sms-FI': 'd.M.yyyy',
        'sq-AL': 'yyyy-MM-dd',
        'sr-Cyrl-BA': 'd.M.yyyy',
        'sr-Cyrl-CS': 'd.M.yyyy',
        'sr-Cyrl-ME': 'd.M.yyyy',
        'sr-Cyrl-RS': 'd.M.yyyy',
        'sr-Latn-BA': 'd.M.yyyy',
        'sr-Latn-CS': 'd.M.yyyy',
        'sr-Latn-ME': 'd.M.yyyy',
        'sr-Latn-RS': 'd.M.yyyy',
        'sv-FI': 'd.M.yyyy',
        'sv-SE': 'yyyy-MM-dd',
        'sw-KE': 'M/d/yyyy',
        'syr-SY': 'dd/MM/yyyy',
        'ta-IN': 'dd-MM-yyyy',
        'te-IN': 'dd-MM-yy',
        'tg-Cyrl-TJ': 'dd.MM.yy',
        'th-TH': 'd/M/yyyy',
        'tk-TM': 'dd.MM.yy',
        'tn-ZA': 'yyyy/MM/dd',
        'tr-TR': 'dd.MM.yyyy',
        'tt-RU': 'dd.MM.yyyy',
        'tzm-Latn-DZ': 'dd-MM-yyyy',
        'ug-CN': 'yyyy-M-d',
        'uk-UA': 'dd.MM.yyyy',
        'ur-PK': 'dd/MM/yyyy',
        'uz-Cyrl-UZ': 'dd.MM.yyyy',
        'uz-Latn-UZ': 'dd/MM yyyy',
        'vi-VN': 'dd/MM/yyyy',
        'wo-SN': 'dd/MM/yyyy',
        'xh-ZA': 'yyyy/MM/dd',
        'yo-NG': 'd/M/yyyy',
        'zh-CN': 'yyyy/M/d',
        'zh-HK': 'd/M/yyyy',
        'zh-MO': 'd/M/yyyy',
        'zh-SG': 'd/M/yyyy',
        'zh-TW': 'yyyy/M/d',
        'zu-ZA': 'yyyy/MM/dd',
    };
    // Forcing US format right now because we were told to
    // TODO: remove this
    return formats['en-US'];
    // return formats[navigator.language] || "dd/MM/yyyy";
}
